import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { createSearchQueryRepository } from '@/scopes/search/search/infrastructure/repositories/searchQueryRepository'

export function useSearchQueryRepository() {
  const queryClient = useQueryClient()

  return useMemo(
    () => createSearchQueryRepository({ queryClient }),
    [queryClient],
  )
}
